import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { clientQuery, clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";

const INIT_STATE = {
    open: false,
    loading: false,
    loadingUpdate: false,
    error: null,
    listCoaches: [],
    dataToCase: {},
    resultUpdate: null,
    updateCoach: null
};

const route = 'modules/driverPerformance/views/cases/modals/editCoachPanel/redux/slice';

export const getCoaches = createAsyncThunk('driverPerformance/editCoachPanel/getCoaches',
    async (payload, { rejectWithValue, getState }) => {
        try {
            let data = await clientQuery(
                `
                query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
                    response: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        firstName
                        lastName
                        userName
                        isSupervisor
                    }
                    total
                    }
                }
                `,
                {
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            data = data?.response?.items || [];
            if (data) {
                const coaches = data?.reduce((acc, item) => {
                    if (item?.isSupervisor === true) {
                        acc.push({
                            ...item,
                            fullname: `${item?.firstName} ${item?.lastName}` || item?.userName
                        });
                    }
                    return acc;
                }, []).sort((a, b) => a.fullname.localeCompare(b.fullname));
                return coaches;
            } else {
                return []
            }
        } catch (exc) {
            ExceptionManager(exc, route, 'getCoaches');
            return rejectWithValue(exc);
        }
    });

export const updateDriverPerformanceCase = createAsyncThunk('driverPerformance/editCoachPanel/updateDriverPerformanceCase',
    async (payload, { rejectWithValue, dispatch, getState }) => {
        const { id, coachId, statusId } = payload;
        try {
            let data = await clientMutation(
                `
                mutation  updateDriverPerformanceCase($id: Int!, $coachId: Int, $statusId: String!) {
                    data: updateDriverPerformanceCase(id: $id, coachId: $coachId, statusId: $statusId) {
                        id
                        coachId
                    }
                }
                `,
                { id, coachId, statusId },
                endpoints.GRAPHQL_GENERAL_V2
            );

            // Enrich with coach info from current coaches list to allow UI update without refetch
            const state = getState();
            const coaches = state.driverPerformanceCasesTabEditCoachRedux?.listCoaches || [];
            const selectedCoach = coaches.find((c) => String(c?.id) === String(coachId));
            const coachUserName = selectedCoach?.userName || selectedCoach?.fullname || "";
            const coachFirstName = selectedCoach?.firstName || "";
            const coachLastName = selectedCoach?.lastName || "";

            return data?.data ? { ...data.data, coachUserName, coachFirstName, coachLastName } : data?.data;
        } catch (exc) {
            ExceptionManager(exc, route, 'updateCoach');
            return rejectWithValue(exc);
        }
    }
);

const updateCoachOfCase = (state, updatedData) => {
    const coachIndex = state.listCoaches.findIndex(coach => coach.id === updatedData.id);
    if (coachIndex !== -1) {
        // Only update the coachId while keeping the memory reference of the existing object
        state.listCoaches[coachIndex].coachId = updatedData.coachId;
        state.resultUpdate = action.payload;
    }
}

const driverPerformanceEditCoachListCoachesRedux = createSlice({
    name: 'driverPerformance/editCoachPanel/listCoaches',
    initialState: INIT_STATE,
    reducers: {
        resetEditCoachPanel: (state, action) => {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalEditCoachPanel: (state, action) => {
            state.open = typeof action.payload === 'boolean' ? action.payload : action.payload.open;
            state.dataToCase = action.payload.dataToCase || {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getCoaches
        builder.addCase(getCoaches.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getCoaches.fulfilled, (state, action) => {
            state.loading = false;
            state.listCoaches = action.payload;
        });
        builder.addCase(getCoaches.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //updateDriverPerformanceCase
        builder.addCase(updateDriverPerformanceCase.pending, (state) => {
            //state.loading = true;
            state.loadingUpdate = true;
        });
        builder.addCase(updateDriverPerformanceCase.fulfilled, (state, action) => {
            //state.loading = false;
            state.loadingUpdate = false;
            state.resultUpdate = action.payload;
            state.updateCoach = action.payload;
            // Update the coach in the local list after a successful mutation
            if (action.payload) {
                updateCoachOfCase(state, action.payload);
            }
        });
        builder.addCase(updateDriverPerformanceCase.rejected, (state, action) => {
            //state.loading = false;
            state.loadingUpdate = false;
            state.error = action.payload;
        });
    },
})

export const { actions, reducer } = driverPerformanceEditCoachListCoachesRedux;

export const { resetEditCoachPanel, openModalEditCoachPanel } = actions;

export default reducer;